import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (page, scrollToId = null) => {
    setIsMenuOpen(false);
    if (scrollToId) {
      // ホームページの特定セクションにスクロール
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          const section = document.getElementById(scrollToId);
          if (section) section.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      } else {
        const section = document.getElementById(scrollToId);
        if (section) section.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(page);
    }
  };

  const styles = {
    header: {
      backgroundColor: '#ffffff',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
    },
    headerContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '15px 40px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    logoContainer: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    },
    logoImage: {
      height: '50px',
      width: 'auto',
    },
    nav: {
      display: 'flex',
      gap: '30px',
    },
    navButton: {
      background: 'none',
      border: 'none',
      fontSize: '16px',
      color: '#374151',
      cursor: 'pointer',
      padding: '8px 12px',
      transition: 'color 0.3s',
      fontWeight: '500',
    },
    hamburger: {
      display: 'none',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '8px',
      zIndex: 1002,
    },
    hamburgerLine: {
      width: '25px',
      height: '3px',
      backgroundColor: '#374151',
      margin: '5px 0',
      transition: 'all 0.3s',
    },
    mobileNav: {
      position: 'fixed',
      top: 0,
      right: isMenuOpen ? 0 : '-100%',
      width: '70%',
      maxWidth: '300px',
      height: '100vh',
      backgroundColor: '#ffffff',
      boxShadow: '-2px 0 8px rgba(0,0,0,0.1)',
      transition: 'right 0.3s ease-in-out',
      zIndex: 1001,
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '80px',
    },
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: isMenuOpen ? 'block' : 'none',
      zIndex: 999,
    },
    mobileNavButton: {
      background: 'none',
      border: 'none',
      fontSize: '16px',
      color: '#374151',
      cursor: 'pointer',
      padding: '20px 40px',
      textAlign: 'left',
      transition: 'background-color 0.3s',
      fontWeight: '500',
      borderBottom: '1px solid #e5e7eb',
    },
  };

  return (
    <>
      <style>
        {`
          @media (max-width: 768px) {
            .desktop-nav {
              display: none !important;
            }
            .hamburger-button {
              display: block !important;
            }
            .header-container {
              padding: 15px 20px !important;
            }
            .logo-image {
              height: 40px !important;
            }
          }
        `}
      </style>
      
      <header style={styles.header}>
        <div style={styles.headerContainer} className="header-container">
          <div style={styles.logoContainer} onClick={() => handleNavigation('/')}>
            <img 
              src={process.env.PUBLIC_URL + '/jtclogo.png'} 
              alt="Japan Tabibito Club" 
              style={styles.logoImage}
              className="logo-image"
            />
          </div>
          
          {/* デスクトップナビ */}
          <nav style={styles.nav} className="desktop-nav">
            <button onClick={() => handleNavigation('/')} style={styles.navButton}>
              ホーム
            </button>
            <button onClick={() => handleNavigation('/news')} style={styles.navButton}>
              お知らせ
            </button>
            <button onClick={() => handleNavigation('/about')} style={styles.navButton}>
              会社情報
            </button>
            <button onClick={() => handleNavigation('/', 'work')} style={styles.navButton}>
              事業
            </button>
            <button onClick={() => handleNavigation('/', 'contact')} style={styles.navButton}>
              お問合せ
            </button>
          </nav>

          {/* ハンバーガーボタン */}
          <button 
            style={styles.hamburger} 
            className="hamburger-button"
            onClick={toggleMenu}
            aria-label="メニュー"
          >
            <div style={styles.hamburgerLine}></div>
            <div style={styles.hamburgerLine}></div>
            <div style={styles.hamburgerLine}></div>
          </button>
        </div>

        {/* オーバーレイ */}
        <div style={styles.overlay} onClick={toggleMenu}></div>

        {/* モバイルナビ */}
        <nav style={styles.mobileNav}>
          <button 
            onClick={() => handleNavigation('/')} 
            style={styles.mobileNavButton}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            ホーム
          </button>
          <button 
            onClick={() => handleNavigation('/news')} 
            style={styles.mobileNavButton}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            お知らせ
          </button>
          <button 
            onClick={() => handleNavigation('/about')} 
            style={styles.mobileNavButton}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            会社情報
          </button>
          <button 
            onClick={() => handleNavigation('/', 'work')} 
            style={styles.mobileNavButton}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            事業
          </button>
          <button 
            onClick={() => handleNavigation('/', 'contact')} 
            style={styles.mobileNavButton}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            お問合せ
          </button>
        </nav>
      </header>
    </>
  );
};

export default Header;